module.exports = __webpack_public_path__ + "img/ring_r_s_1_1@2x.4f272b87.png";